
     export const
     server = 'https://lgltrax.lglship.com/' //lglangnode
         //server = '/' //lglangnode using proxy
         //server = 'http://localhost:22110/'
          //  server = "https://lglship-brownrlb.c9users.io/"
     //  server = 'http://lglnode.lglship.com/'//lglship
     ;






// WEBPACK FOOTER //
// ./src/app/services/constants.ts